export default {
  title: 'Modifizierer',
  master_title: 'Marken-Modus - Modifizierer',
  products_creation_disabled:
    'Aufgrund der aktiven Integration mit {{integration}} ist die Erstellung neuer Produkte nicht möglich. Wenn Sie das Menü ändern müssen, nehmen Sie die Änderungen bitte in {{integration}} vor und synchronisieren Sie das Menü.',
  labels: {
    select_all: 'Alle auswählen',
  },
  buttons: {
    add_modifier: 'Modifizierer hinzufügen',
    delete_selected: 'Ausgewählte löschen',
    refresh: 'Aktualisieren',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
};
